"use strict";
var $ = require("../internals/export");
var IS_PURE = require("../internals/is-pure");
var FORCED_PROMISE_CONSTRUCTOR = require("../internals/promise-constructor-detection").CONSTRUCTOR;
var NativePromiseConstructor = require("../internals/promise-native-constructor");
var getBuiltIn = require("../internals/get-built-in");
var isCallable = require("../internals/is-callable");
var defineBuiltIn = require("../internals/define-built-in");
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
$({ target: "Promise", proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  "catch": function(onRejected) {
    return this.then(void 0, onRejected);
  }
});
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn("Promise").prototype["catch"];
  if (NativePromisePrototype["catch"] !== method) {
    defineBuiltIn(NativePromisePrototype, "catch", method, { unsafe: true });
  }
}
